export default function (_this) {
    return {
      async create (data, cb) {
        // const ganttOptions = {
        //   title: data.title,
        // //   id: data.id,
        //   name: data.name,
        //   start_date: data.start_date,
        //   end_date: data.end_date,
        //   assignedTo: data.assignedTo,
        // //   percent: data.percent,
        // //   duration: data.duration,
        //   dataGrid: data.dataSource
        // }
        const ganttOptions = data
        const ganttId = await new Promise((resolve) => {
          const key = _this.getRef('widgetsData/ganttDataSimple').push(ganttOptions, () => {
            resolve(key)
          }).key
        })

        const widget = {
          template: `<GanntSimple :chartId="'${ganttId}'" />`,
          gsOptions: {
            x: 0,
            y: 0,
            w: 24,
            h: 18
          },
          tab: data.tab,
          subtab: data.subtab || null,
          layout: 'b-card'
        }

        const widgetKey = await new Promise((resolve) => {
          _this.widgets.create(widget, (key) => {
            resolve(key)
          })
        })
        _this.getRef(`widgets/${widgetKey}/dependency`)
        .set(`ganttData/${ganttId}`, () => (cb()))
      },
      readOptions (ganttId, cb) {
        _this.getRef('widgetsData/ganttDataSimple')
        .child(ganttId)
        .on('value', (snapshot) => {
          cb(snapshot.val())
        })
      },
      saveOptions (ganttId, options, cb) {
        _this.getRef('widgetsData/ganttDataSimple')
        .child(ganttId)
        .set(options, () => (cb()))
      }
    }
  }
